import React from 'react';
import {analyticsEvent} from '../../utils/analytics';

import './accordion.scss';

const apiLogo = process.env.REACT_APP_MAP_API_LOGO;
function AccordionContent(props: any) {
    const analyticsClick = () => {
        analyticsEvent('Serveis i operadors', 'servicesoperators_moreinfolink_click', props.title);
    };
    return (<div className="accordion__content">
        <div className="content-box">
            <div className="header-box"
                onKeyDown={analyticsClick}
                role='button'
                tabIndex={0}
                onClick={analyticsClick}
            >
                <img src={`${apiLogo}${props.logo}`} alt="logo"></img>
                <a className={`title ${!!props.web_url ? 'external-link': ''}`} href={props.web_url} target='_blank' rel="noreferrer">
                    {props.title}
                </a>
            </div>
            <div className="description">
                {props.description}
            </div>
        </div>
    </div>
    );
}

export default AccordionContent;
